module.exports = require("babel-runtime/core-js/get-iterator");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/get-iterator"
// module id = 25
// module chunks = 0